(function () {
  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function formatMoneyCompact(cents, format) {
    return formatMoney(cents, format).replace(/([.,]00)(?=\D*$)/, '');
  }

  function parseJsonScript(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function parseVariants(root) {
    var productData = parseJsonScript(root.querySelector('[data-nw-fp-product-json]'));
    return productData && productData.variants ? productData.variants : [];
  }

  function findVariant(variants, selectedOptions) {
    return variants.find(function (variant) {
      if (!variant.options) return false;
      return variant.options.every(function (optionValue, index) {
        return selectedOptions[index] === undefined || selectedOptions[index] === optionValue;
      });
    });
  }

  function normalizeSizeName(name) {
    var value = String(name || '').trim().toLowerCase();
    if (value === 'california king') return 'cal king';
    return value;
  }

  function sizesMatch(a, b) {
    return normalizeSizeName(a) === normalizeSizeName(b);
  }

  function getSaveLabel(root, amount) {
    var template = root.getAttribute('data-save-template');
    if (template) return template.replace('__AMOUNT__', amount);
    return 'SAVE ' + amount;
  }

  function refreshAffirm(root, amountCents) {
    if (!root) return;

    var amount = String(amountCents);
    var affirmEls = root.querySelectorAll('[data-nw-fp-affirm]');
    if (!affirmEls.length) return;

    affirmEls.forEach(function (affirmEl) {
      affirmEl.setAttribute('data-amount', amount);
      affirmEl.textContent = '';
    });

    function runAffirmRefresh() {
      if (typeof window.affirm === 'undefined' || !window.affirm.ui) return false;
      window.affirm.ui.ready(function () {
        window.affirm.ui.refresh();
      });
      return true;
    }

    if (!runAffirmRefresh()) {
      bootstrapAffirm(root);
      stripAffirmFromVariantPills(root);
      return;
    }

    setTimeout(function () {
      runAffirmRefresh();
      stripAffirmFromVariantPills(root);
    }, 150);
  }

  function hydrateAffirm(root) {
    if (typeof window.affirm === 'undefined' || !window.affirm.ui) return false;
    window.affirm.ui.ready(function () {
      window.affirm.ui.refresh();
    });
    return true;
  }

  function bootstrapAffirm(root) {
    if (hydrateAffirm(root)) return;

    var existingScript = document.querySelector('script[src*="affirm.com/js"]');
    if (existingScript || window.__nwFpAffirmBootstrapped) {
      var waitAttempts = 0;
      var waitPoll = setInterval(function () {
        waitAttempts += 1;
        if (hydrateAffirm(root) || waitAttempts >= 80) clearInterval(waitPoll);
      }, 250);
      return;
    }

    var publicKey = root.getAttribute('data-affirm-public-key');
    if (!publicKey) return;

    window.__nwFpAffirmBootstrapped = true;
    window._affirm_config = {
      public_api_key: publicKey,
      script: 'https://cdn1.affirm.com/js/v2/affirm.js',
      locale: 'en_US',
      country_code: 'USA'
    };

    (function (l, g, m, e, a, f, b) {
      var d;
      var c = l[m] || {};
      var h = document.createElement(f);
      var n = document.getElementsByTagName(f)[0];
      var k = function (obj, method, args) {
        return function () {
          obj[method]._.push([args, arguments]);
        };
      };
      c[e] = k(c, e, 'set');
      d = c[e];
      c[a] = {};
      c[a]._ = [];
      d._ = [];
      c[a][b] = k(c, a, b);
      a = 0;
      for (b = 'set add save post open empty reset on off trigger ready setProduct'.split(' '); a < b.length; a++) {
        d[b[a]] = k(c, e, b[a]);
      }
      a = 0;
      for (b = ['get', 'token', 'url', 'items']; a < b.length; a++) {
        d[b[a]] = function () {};
      }
      h.async = true;
      h.src = g[f];
      n.parentNode.insertBefore(h, n);
      delete g[f];
      d(g);
      l[m] = c;
    })(window, window._affirm_config, 'affirm', 'checkout', 'ui', 'script', 'ready');

    var loadAttempts = 0;
    var loadPoll = setInterval(function () {
      loadAttempts += 1;
      if (hydrateAffirm(root) || loadAttempts >= 80) clearInterval(loadPoll);
    }, 250);
  }

  function initAffirm(root) {
    if (!root.querySelector('[data-nw-fp-affirm]')) return;
    bootstrapAffirm(root);
  }

  window.__nwFpBootstrapAffirm = bootstrapAffirm;
  window.__nwFpHydrateAffirm = hydrateAffirm;
  window.__nwFpRefreshAffirm = refreshAffirm;

  function openCart() {
    if (window.kachingCartApi && typeof window.kachingCartApi.openCart === 'function') {
      window.kachingCartApi.openCart();
      return true;
    }
    return false;
  }

  function closeSizeGuide(modal) {
    if (!modal) return;
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nw-fp-size-guide-open');
    if (modal._nwFpOpener && typeof modal._nwFpOpener.focus === 'function') {
      modal._nwFpOpener.focus();
    }
  }

  function initSizeGuide(root) {
    var modal = root.querySelector('[data-nw-fp-size-guide-modal]');
    if (!modal || modal.getAttribute('data-nw-fp-size-guide-ready') === 'true') return;
    modal.setAttribute('data-nw-fp-size-guide-ready', 'true');

    function openModal(opener) {
      modal._nwFpOpener = opener || null;
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('nw-fp-size-guide-open');
      var closeBtn = modal.querySelector('[data-nw-fp-size-guide-close]');
      if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
    }

    root.querySelectorAll('[data-nw-fp-size-guide-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn);
      });
    });

    modal.querySelectorAll('[data-nw-fp-size-guide-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closeSizeGuide(modal);
      });
    });

    if (!modal._nwFpEscapeBound) {
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal.classList.contains('is-active')) {
          closeSizeGuide(modal);
        }
      });
      modal._nwFpEscapeBound = true;
    }
  }

  function notifyCartRefresh(payload) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, detail: { item: payload } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  }

  function addItemsToCart(rootUrl, items) {
    return fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  function findGiftVariant(giftProduct, selectedSize) {
    if (!giftProduct || !giftProduct.variants || !giftProduct.variants.length) return null;

    if (selectedSize) {
      var matched = giftProduct.variants.find(function (giftVariant) {
        return sizesMatch(giftVariant.title, selectedSize);
      });
      if (matched) return matched;
    }

    if (giftProduct.variants.length === 1 || giftProduct.has_only_default_variant) {
      return giftProduct.variants[0];
    }

    return giftProduct.variants.find(function (giftVariant) {
      return giftVariant.available;
    }) || giftProduct.variants[0];
  }

  function initProductForm(root) {
    var form = root.querySelector('[data-nw-fp-form]');
    var submitBtn = root.querySelector('[data-nw-fp-submit]');
    if (!form || !submitBtn || form.getAttribute('data-nw-fp-form-ready') === 'true') return;
    form.setAttribute('data-nw-fp-form-ready', 'true');

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (submitBtn.disabled) return;

      var originalText = submitBtn.textContent;
      var addingLabel = root.getAttribute('data-adding-label') || 'Adding...';
      submitBtn.disabled = true;
      submitBtn.textContent = addingLabel;

      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var variantInput = form.querySelector('[data-nw-fp-variant-id]') || form.querySelector('input[name="id"]');
      var mainVariantId = variantInput ? parseInt(variantInput.value, 10) : NaN;
      var selectedTrigger = root.querySelector('.nw-variant-trigger:checked') || form.querySelector('.nw-variant-trigger:checked');
      var selectedSize = selectedTrigger ? selectedTrigger.getAttribute('data-variant-title') || '' : '';
      var giftProduct = parseJsonScript(
        root.querySelector('[data-nw-fp-gift-product-json]') || document.querySelector('[data-nw-fp-gift-product-json]')
      );

      var itemsToAdd = [];
      if (mainVariantId) {
        itemsToAdd.push({
          id: mainVariantId,
          quantity: 1
        });
      }

      var giftVariant = findGiftVariant(giftProduct, selectedSize);
      if (giftVariant) {
        itemsToAdd.push({
          id: giftVariant.id,
          quantity: 1,
          properties: {
            _free_gift: 'true',
            'Free Gift': 'true'
          }
        });
      }

      function restoreButton() {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      }

      function finishSuccess(cartData) {
        restoreButton();
        notifyCartRefresh(cartData);
        if (!openCart()) {
          window.location.href = rootUrl + 'cart';
        }
      }

      if (!itemsToAdd.length) {
        restoreButton();
        return;
      }

      addItemsToCart(rootUrl, itemsToAdd)
        .then(finishSuccess)
        .catch(function () {
          if (itemsToAdd.length > 1) {
            return addItemsToCart(rootUrl, [itemsToAdd[0]]).then(finishSuccess);
          }
          throw new Error('cart-add-failed');
        })
        .catch(function () {
          restoreButton();
        });
    });
  }

  function applyRadioVariant(root, input) {
    if (!root || !input) return;

    var varId = input.getAttribute('data-variant-id');
    var varTitle = input.getAttribute('data-variant-title');
    var price = input.getAttribute('data-formatted-price');
    var comparePrice = input.getAttribute('data-compare-price');
    var saveAmount = input.getAttribute('data-save-amount');
    var priceCents = input.getAttribute('data-variant-price');

    root.querySelectorAll('[data-nw-fp-variant-id]').forEach(function (idInput) {
      if (varId) idInput.value = varId;
    });

    var titleEl = root.querySelector('[data-selected-option-value]');
    if (titleEl && varTitle) titleEl.textContent = varTitle;

    var priceEl = root.querySelector('[data-nw-fp-price]');
    if (priceEl && price) priceEl.textContent = price;

    var compareEl = root.querySelector('[data-nw-fp-compare]');
    if (compareEl) {
      if (comparePrice) {
        compareEl.textContent = comparePrice;
        compareEl.hidden = false;
        compareEl.removeAttribute('hidden');
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }

    var saveEl = root.querySelector('[data-nw-fp-save]');
    if (saveEl) {
      if (saveAmount) {
        saveEl.textContent = getSaveLabel(root, saveAmount);
        saveEl.hidden = false;
        saveEl.removeAttribute('hidden');
      } else {
        saveEl.textContent = '';
        saveEl.hidden = true;
      }
    }

    var submitBtn = root.querySelector('[data-nw-fp-submit]');
    if (submitBtn) {
      var available = !input.disabled;
      submitBtn.disabled = !available;
      submitBtn.textContent = available
        ? submitBtn.getAttribute('data-label-available') || submitBtn.textContent
        : submitBtn.getAttribute('data-label-sold-out') || 'Sold out';
    }

    if (priceCents) refreshAffirm(root, priceCents);
    stripAffirmFromVariantPills(root);
  }

  function applyJsonVariant(root, variant, selectedOptions) {
    if (!variant) return;

    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var showSaveBadge = root.getAttribute('data-show-save-badge') === 'true';

    root.querySelectorAll('[data-nw-fp-variant-id]').forEach(function (input) {
      input.value = variant.id;
    });

    var priceEl = root.querySelector('[data-nw-fp-price]');
    if (priceEl) priceEl.textContent = formatMoneyCompact(variant.price, moneyFormat);

    var compareEl = root.querySelector('[data-nw-fp-compare]');
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoneyCompact(variant.compare_at_price, moneyFormat);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    var saveEl = root.querySelector('[data-nw-fp-save]');
    if (saveEl) {
      if (showSaveBadge && variant.compare_at_price && variant.compare_at_price > variant.price) {
        saveEl.textContent = getSaveLabel(root, formatMoneyCompact(variant.compare_at_price - variant.price, moneyFormat));
        saveEl.hidden = false;
      } else {
        saveEl.hidden = true;
      }
    }

    root.querySelectorAll('[data-nw-fp-variant-option]').forEach(function (button) {
      var optionIndex = Number(button.getAttribute('data-option-index'));
      var optionValue = button.getAttribute('data-option-value');
      var isSelected = selectedOptions[optionIndex] === optionValue;
      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    var submitBtn = root.querySelector('[data-nw-fp-submit]');
    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available
        ? submitBtn.getAttribute('data-label-available') || submitBtn.textContent
        : submitBtn.getAttribute('data-label-sold-out') || 'Sold out';
    }

    refreshAffirm(root, variant.price);
  }

  function ensureRadioVariant(root) {
    var radios = root.querySelectorAll('.nw-variant-trigger');
    if (!radios.length) return false;

    var checked = root.querySelector('.nw-variant-trigger:checked');
    var fallback = root.querySelector('.nw-variant-trigger:not([disabled])') || radios[0];
    var active = checked && !checked.disabled ? checked : fallback;
    if (active && active !== checked) active.checked = true;
    applyRadioVariant(root, active);
    return true;
  }

  function initVariantPicker(root) {
    if (root.getAttribute('data-nw-fp-variant-ready') === 'true') return;
    root.setAttribute('data-nw-fp-variant-ready', 'true');

    if (ensureRadioVariant(root)) {
      root.addEventListener('change', function (event) {
        var input = event.target;
        if (!input.classList || !input.classList.contains('nw-variant-trigger') || !input.checked) return;
        applyRadioVariant(root, input);
      });
      return;
    }

    var variants = parseVariants(root);
    var variantInput = root.querySelector('[data-nw-fp-variant-id]');
    var optionButtons = root.querySelectorAll('[data-nw-fp-variant-option]');
    if (!variants.length) return;

    var initialVariant = variants.find(function (variant) {
      return String(variant.id) === String(variantInput && variantInput.value);
    }) || variants.find(function (variant) {
      return variant.available;
    }) || variants[0];

    var selectedOptions = initialVariant && initialVariant.options ? initialVariant.options.slice() : [];

    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        selectedOptions[Number(button.getAttribute('data-option-index'))] = button.getAttribute('data-option-value');
        var variant = findVariant(variants, selectedOptions);
        if (variant) applyJsonVariant(root, variant, selectedOptions);
      });
    });

    applyJsonVariant(root, initialVariant, selectedOptions);
  }

  function loadSwiper(callback) {
    if (typeof window.__nwLaborLoadSwiper === 'function') {
      window.__nwLaborLoadSwiper(callback);
      return;
    }
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    var script = document.querySelector('#swiper-bundle-js');
    if (script) {
      script.addEventListener('load', callback);
    }
  }

  function initGallery(container) {
    var galleryEl = container.matches && container.matches('[data-nw-fp-gallery]')
      ? container
      : container.querySelector('[data-nw-fp-gallery]');
    if (!galleryEl) return;
    if (galleryEl.getAttribute('data-nw-fp-gallery-ready') === 'true') return;
    galleryEl.setAttribute('data-nw-fp-gallery-ready', 'true');

    var mainSwiperEl = galleryEl.querySelector('[data-nw-fp-main-swiper]');
    if (!mainSwiperEl) return;

    var slides = mainSwiperEl.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    var thumbBtns = galleryEl.querySelectorAll('[data-thumb-index]');
    var prevBtn = galleryEl.querySelector('[data-nw-fp-gallery-prev]');
    var nextBtn = galleryEl.querySelector('[data-nw-fp-gallery-next]');
    var paginationEl = galleryEl.querySelector('[data-nw-fp-gallery-pagination]');

    function updateActiveThumb(index) {
      thumbBtns.forEach(function (btn, i) {
        var isActive = i === index;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (isActive && typeof btn.scrollIntoView === 'function') {
          btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    }

    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var idx = parseInt(btn.getAttribute('data-thumb-index'), 10);
        if (isNaN(idx)) return;
        if (mainSwiperEl.swiper && typeof mainSwiperEl.swiper.slideTo === 'function') {
          mainSwiperEl.swiper.slideTo(idx);
        }
        updateActiveThumb(idx);
      });
    });

    function createSwiperInstance() {
      if (typeof Swiper === 'undefined') return;
      if (mainSwiperEl.swiper) {
        try {
          mainSwiperEl.swiper.destroy(true, true);
        } catch (err) {}
      }

      new Swiper(mainSwiperEl, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        loop: false,
        speed: 300,
        grabCursor: true,
        watchOverflow: true,
        navigation: prevBtn && nextBtn ? { prevEl: prevBtn, nextEl: nextBtn } : false,
        pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
        on: {
          slideChange: function () {
            updateActiveThumb(this.activeIndex);
          }
        }
      });
    }

    loadSwiper(createSwiperInstance);
  }

  function initGiftCarousel(container) {
    var carouselEl = container.matches && container.matches('[data-nw-fp-gift-carousel]')
      ? container
      : container.querySelector('[data-nw-fp-gift-carousel]');
    if (!carouselEl) return;
    if (carouselEl.getAttribute('data-nw-fp-gift-ready') === 'true') return;
    carouselEl.setAttribute('data-nw-fp-gift-ready', 'true');

    var slides = carouselEl.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    var prevBtn = carouselEl.querySelector('[data-nw-fp-gift-prev]');
    var nextBtn = carouselEl.querySelector('[data-nw-fp-gift-next]');
    var paginationEl = carouselEl.querySelector('[data-nw-fp-gift-pagination]');

    function createGiftSwiper() {
      if (typeof Swiper === 'undefined') return;
      if (carouselEl.swiper) {
        try {
          carouselEl.swiper.destroy(true, true);
        } catch (err) {}
      }

      new Swiper(carouselEl, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        loop: false,
        speed: 300,
        grabCursor: true,
        watchOverflow: true,
        navigation: prevBtn && nextBtn ? { prevEl: prevBtn, nextEl: nextBtn } : false,
        pagination: paginationEl ? { el: paginationEl, clickable: true } : false
      });
    }

    loadSwiper(createGiftSwiper);
  }

  function stripAffirmFromVariantPills(root) {
    if (!root) return;
    root.querySelectorAll(
      '.nw_labor_fp__variant-picker .affirm-as-low-as, .nw_labor_fp__pill-label .affirm-as-low-as, .nw_labor_fp__option-values .affirm-as-low-as'
    ).forEach(function (el) {
      el.remove();
    });
  }

  function initVariantPillsAffirmGuard(root) {
    var picker = root.querySelector('[data-nw-fp-variant-pills], .nw_labor_fp__variant-picker');
    if (!picker) return;

    stripAffirmFromVariantPills(root);
    if (picker._nwFpAffirmGuard) return;

    var observer = new MutationObserver(function () {
      stripAffirmFromVariantPills(root);
    });
    observer.observe(picker, { childList: true, subtree: true });
    picker._nwFpAffirmGuard = observer;
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-nw-fp-initialized') === 'true') return;
    root.setAttribute('data-nw-fp-initialized', 'true');
    initVariantPicker(root);
    initVariantPillsAffirmGuard(root);
    initSizeGuide(root);
    initProductForm(root);
    initAffirm(root);
  }

  function resetReadyFlags(scope) {
    scope.querySelectorAll('[data-nw-fp-gallery-ready], [data-nw-fp-gift-ready], [data-nw-fp-initialized], [data-nw-fp-variant-ready], [data-nw-fp-form-ready], [data-nw-fp-size-guide-ready]').forEach(function (el) {
      el.removeAttribute('data-nw-fp-gallery-ready');
      el.removeAttribute('data-nw-fp-gift-ready');
      el.removeAttribute('data-nw-fp-initialized');
      el.removeAttribute('data-nw-fp-variant-ready');
      el.removeAttribute('data-nw-fp-form-ready');
      el.removeAttribute('data-nw-fp-size-guide-ready');
    });
  }

  function initAll(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-nw-fp-gallery]').forEach(initGallery);
    context.querySelectorAll('[data-nw-fp-gift-carousel]').forEach(initGiftCarousel);
    context.querySelectorAll('.nw_labor_fp [data-nw-fp-root], [data-nw-fp-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  window.addEventListener('load', function () {
    document.querySelectorAll('[data-nw-fp-root]').forEach(initAffirm);
  });

  document.addEventListener('shopify:section:load', function (event) {
    resetReadyFlags(event.target);
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.querySelector('[data-nw-fp-size-guide-modal]')) {
      document.body.classList.remove('nw-fp-size-guide-open');
    }
  });
})();
